import * as React from 'react';
export const IcChildrenGame = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-3 4a2 2 0 110 4 2 2 0 010-4zM7 8a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1V8zm4.14 7.39l-.75 1.25a.752.752 0 01-.64.36h-1.5a.75.75 0 01-.64-.36l-.75-1.25a.73.73 0 010-.78l.75-1.25a.75.75 0 01.64-.36h1.5a.75.75 0 01.64.36l.75 1.25a.73.73 0 010 .78zM17 16.63a.74.74 0 01-.64.37h-2.74a.74.74 0 01-.64-1.11l1.37-2.5a.79.79 0 011.32 0l1.33 2.5a.73.73 0 010 .74z'
      fill='currentColor'
    />
  </svg>
);
